import { ApolloClient } from '@apollo/client';

import {
  GetApplicationWalkDocument,
  GetApplicationWalkQuery,
  GetApplicationWalkQueryVariables
} from '../generated/graphql';
import { reconcileTabWalk, TabWalk } from './applicationEditSession';

/**
 * Read the walk the server has open on a group (by the group's id or any of its
 * Applications') and reconcile this tab with it. Always from the network: the
 * open walk is server state another tab can replace at any moment.
 */
export async function readTabWalk(
  apolloClient: ApolloClient<unknown>,
  id: string
): Promise<TabWalk> {
  const { data } = await apolloClient.query<
    GetApplicationWalkQuery,
    GetApplicationWalkQueryVariables
  >({
    query: GetApplicationWalkDocument,
    variables: { id },
    fetchPolicy: 'network-only'
  });
  const group = data?.getApplicationGroup;
  if (!group) throw new Error(`No application group found for ${id}`);
  return reconcileTabWalk({
    applicationGroupId: String(group.applicationGroupId),
    hasSubmission: group.hasSubmission,
    openEdit: group.openEdit
  });
}
